import { BCMSRecord, DisabledPrompt, Link, useBCMSContext, useModel, useParams, useRoute } from "@bcm-dev/bcms-vite";
import MainContentContainer, { MainContentHeader } from 'components/shared/containers/MainContentContainer';
import TransactionView from 'components/shared/views/BaseRowView/components/TransactionView';
import Classes, { Card, Transaction } from "model";
import React from 'react';
import CreditCardSummaryWidget from './components/CreditCardSummaryWidget';
import NoRecentTransactionsWidget from './components/NoRecentTransactionsWidget';
import "./styles.css";
/**
 * @function RecentTransactionsPage
 * @return {React.Component}
 * @exported true
 * @description The main component for RecentTransactionsPage
 */
export default function RecentTransactionsPage(props) {
  const globalController = useBCMSContext();
  const navigate = useRoute();

  const defaultCard = globalController.state.branding.options.include_debit_chw23 !== "false" ? "0" : "1";
  let cardID = useParams().cardID ?? defaultCard;
  const { branding } = useModel();
  const options = branding.options ?? {};
  // If the credit card is off, then debit card has to be used.
  if(options.include_credit_chw23 === "false") {
      cardID = "0";
  }

  BCMSRecord.globalControllerFor(Classes, globalController);

  const card = Card.initByID(cardID);
  // Filter all cards by the card id and then sort by date
  let transactions = Transaction.initAll().filter(transaction => transaction.card.id === cardID, [])

  if (globalController.state.branding.options.credit_select_chw23 !== "true") {
    transactions = transactions.filter((transaction) => transaction.merchant.name !== "Payment")
  }
  transactions = transactions.sort((a, b) => {
    if (a.purchaseDate.isBefore(b.purchaseDate)) { return 1; }
    else if (a.purchaseDate.isAfter(b.purchaseDate)) { return -1; }
    else { return 0; }
  })
    .map(transaction => {
      const isCredit = transaction.credit === true;

      return (
        transaction.merchant.name !== "Payment" ?
          <TransactionView
            dataPoint={`Transaction_${transaction.id}`}
            billerName={transaction.merchant.name}
            date={transaction.purchaseDate.format("M d, Y")}
            amount={`${isCredit ? "+" : ""}${transaction.amount.format()}`}
            leftIcon={transaction.merchant.logo}
            positiveClassName={isCredit ? "is-credit" : ""}
            key={`transaction_${transaction.id}`}
            id={transaction.id}
            onClick={transaction.merchant.name !== "Payment" ? evt => navigate(`/home/transactiondetails/${card.id}/${transaction.id}`) : () => { }} />
          :
          <div key={ `transaction_${transaction.id}` }>
            <DisabledPrompt>
              <TransactionView
              dataPoint={`Transaction_${transaction.id}`}
              billerName={transaction.merchant.name}
              date={transaction.purchaseDate.format("M d, Y")}
              amount={`${isCredit ? "+" : ""}${transaction.amount.format()}`}
              leftIcon={transaction.merchant.logo}
              positiveClassName={isCredit ? "is-credit" : ""}
              key={`transaction_${transaction.id}`}
              id={transaction.id}
              onClick={transaction.merchant.name !== "Payment" ? evt => navigate(`/home/transactiondetails/${card.id}/${transaction.id}`) : () => { }} />
          </DisabledPrompt>
        </div>
      );
    }, []);

  const recentTransactions = transactions.slice(0, card.type === "credit" ? 8 : 10);
  const viewAllDisabled = card.active === false || card.recentlyAdded === true || recentTransactions.length === 0;

  return (
    <div className="recent-transactions-page flex-container flex-vertical">
      {/* only shown for credit cards */}
      {card.type === "credit" && <CreditCardSummaryWidget />}

      {recentTransactions.length === 0 || card.active === false
        ? <MainContentContainer className="no-transactions-list"
          header={
            <MainContentHeader text="Recent Transactions" dataPoint="Recent_Transaction_Header" key={card.id} >
              <DisabledPrompt>
              <Link  to={`/home/viewalltransactions/purchases/${card.id}`} dataPoint="Recent_Transactions_View_All">View All</Link>
              </DisabledPrompt>
            </MainContentHeader>
          }>
          <NoRecentTransactionsWidget />
        </MainContentContainer>
        
        : <MainContentContainer className="recent-transactions-list"
          header={
            <MainContentHeader text="Recent Transactions" dataPoint="Recent_Transaction_Header">
              <Link className={viewAllDisabled ? "disabled" : ""} to={`/home/viewalltransactions/purchases/${card.id}`} dataPoint="Recent_Transactions_View_All">View All</Link>
            </MainContentHeader>
          }>
          {/* this repeats */}
          {recentTransactions}
        </MainContentContainer>
      }
    </div>
  );
}
